// Business figures shown on the landing. Update here only — every section reads from this file.
// PLACEHOLDER = value to be confirmed by the owner.

export const marginExample = {
  productName: "Abito Fiorella",
  productCode: "MB204",
  mboPrice: 15, // PLACEHOLDER: prezzo di acquisto MBO in €
  markupMin: 3, // ricarico reale x3
  markupMax: 4, // ricarico reale x4
  disclaimer: "I margini variano in base al capo scelto e al posizionamento del tuo brand.",
};

export const keyNumbers = [
  { value: "x3 – x4", label: "Ricarico sul prezzo di acquisto MBO" },
  { value: "48 – 96h", label: "Spedizione in Italia ed Europa", sub: "24 – 48h in Spagna" },
  { value: "Nessuno", label: "Ordine minimo sui prodotti" },
];

export const trustBadges = [
  "Hub logistico Valencia",
  "Hub logistico Milano",
  "Zero stock in anticipo",
  "Branding on demand",
];

export const heroBullets = ["Zero stock immobilizzato", "Il tuo brand su ogni capo", "Spedizione diretta al cliente"];
